const playerId = 'youtube-player';
const containerClass = 'product-gallery__video-container';
const youtubeUrl = 'https://www.youtube.com/v/{videoId}?version=3'
const youtubeApi = "https://www.youtube.com/iframe_api";
let videoTitle = "Video"
export default class YoutubePlayer {
  constructor(videoTitleString) {
    videoTitle = videoTitleString;
  }

  loadIframeApi() {
    let tag = document.createElement('script');
    tag.src = youtubeApi;
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  createPlayerHtml() {
    let currentContainer = document.getElementById(containerClass);
    if (!currentContainer) {
      let videoContainer = document.createElement('div');
      videoContainer.classList.add(containerClass);
      videoContainer.setAttribute("aria-label", videoTitle)
      videoContainer.id = containerClass;
      let playerDiv = document.createElement('div');
      playerDiv.id = playerId;
      videoContainer.appendChild(playerDiv);
      let container =
        document.getElementsByClassName("product-gallery__slide--active")[0];
      container.innerHTML = "";
      container.appendChild(videoContainer);
    } else {
      this.reset();
      currentContainer.parentNode.removeChild(currentContainer);
      let container =
        document.getElementsByClassName("product-gallery__slide--active")[0];
      container.innerHTML = "";
      container.appendChild(currentContainer);
    }
  }

  getYoutubeObject() {
    this.reset();
    return new Promise((resolve) => {
      if (window.YT) {
        return resolve(window.YT);
      }
      window.onYouTubeIframeAPIReady = () => {
        resolve(window.YT);
      };
      this.loadIframeApi();
    });
  }

  initPlayer(playerId, additionalOptions = {}) {
    return new Promise((resolve) => {
      if (window.player) {
        return resolve();
      }
      let options = {
        playerVars: {rel: 0},
        width: additionalOptions.width,
        height: additionalOptions.height,
        events: {
          'onReady': () => {
            resolve();
          }
        }
      };
      // eslint-disable-next-line no-undef
      window.player = new YT.Player(playerId, options);
    });
  }

  handlePlay(data, createPlayer = false) {
    let videoId = data.youtubeVideoId;
    let video = data;
    if (createPlayer) {
      this.createPlayerHtml();
    }
    this.getYoutubeObject()
      .then(() => this.initPlayer(video.playerId, video))
      .then(() => this.play(videoId));
  }

  play(videoId) {
    let player = window.player;
    if (player.getVideoData()['video_id'] === videoId) {
      player.playVideo()
    } else {
      player.loadVideoByUrl(youtubeUrl.replace('{videoId}', videoId))
    }
  }

  reset() {
    if (window.player) {
      window.player.destroy();
      window.player = null;
    }
  }
}

